<template>
    <DsCard
        class="unlayer-template-card"
        :disabled="selected || disabled"
    >
        <div v-if="loading" class="placeholder">
            <DsPlaceholder
                :rows="[
                    { height: '2rem', boxes: [3, 1] },
                    { height: '3.5rem', boxes: [1] },
                    { height: '3.5rem', boxes: [1] },
                ]"
            />
        </div>

        <template v-else>
            <img :src="template.previewUrl" />

            <div v-if="selected" class="template-overlay">
                <DsSpinner />
            </div>

            <div v-else class="template-overlay template-details">
                <DsFilledButton
                    class="select-button"
                    @click="$emit('click')"
                >
                    {{ $t('unlayerBuilder.templateSelection.selectTemplate') }}
                </DsFilledButton>

                <DsTextButton
                    v-if="previewEnabled"
                    leading-icon="eye-show"
                    class="preview-button"
                    data-qa="campaign-email-preview-button"
                    :loading="isLoadingPreview"
                    @click="$emit('preview')"
                >
                    {{ $t('global.preview') }}
                </DsTextButton>
            </div>
        </template>
    </DsCard>
</template>

<script>
export default {
    props: {
        template: {
            type: Object,
            required: true,
        },
        selected: Boolean,
        disabled: Boolean,
        isLoadingPreview: Boolean,
        previewEnabled: Boolean,
    },

    data() {
        return {
            loading: false,
        };
    },

    created() {
        this.loading = true;

        const image = new Image();

        image.addEventListener('load', () => {
            this.$nextTick(() => {
                this.loading = false;
            });
        });

        image.src = this.template.previewUrl;
    },
};
</script>

<style lang="scss" scoped>
.unlayer-template-card {
    padding: 0;
    overflow: hidden;
    position: relative;
}

.template-overlay {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba($color-paper, .7);
}

.unlayer-template-card:not(:hover) .template-details {
    display: none;
}

.select-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    --icon-size: 1rem;

    span {
        @include margin-start($spacing-100);
    }
}

.preview-button {
    margin-top: $spacing-100;
}

.placeholder {
    padding: $spacing-200;
}
</style>
